import {useTheme} from "@emotion/react";
import Select, {components} from "react-select";
import arrow from "../../../assets/images/advanced-search-chevron-down.png";
import CTA from "../../../elements/CTA/index.jsx";
import TitleUnderlinedAnimated from "../../../elements/TitleUnderlinedAnimated/index.jsx";
import {Text} from "../../../elements/text/index.js";
import {MobileOptionsModal} from "../../sections/SectionPlanTrip/mobileOptionsModal.jsx";
import {CTAWrapper, Emodji, FilterWrapper, TitleWrapper} from "./styles.js";

const MOCK_DATA = {
  emodjiDestination: "🌍",
  emodjiDuration: "⏳",
  cta: {
    title: "Rechercher",
    url: "/",
    target: "_blank",
  },
};

export const HeaderText = ({title, text}) => {
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  return (
    <TitleWrapper>
      {title && (
        <TitleUnderlinedAnimated
          hideUnderline={true}
          type={"titleExtraLarge"}
          wrapperStyles={{marginBottom: 24}}
        >
          {title}
        </TitleUnderlinedAnimated>
      )}

      <Text type="titleExtraSmall" styles={{marginBottom: isMobile ? 24 : 40}}>
        {text}
      </Text>
    </TitleWrapper>
  );
};

const DropdownIndicator = (props) => {
  const {menuIsOpen} = props.selectProps;
  return (
    <components.DropdownIndicator {...props}>
      <img
        style={{
          width: 24,
          height: 24,
          transition: "transform 0.3s ease",
          transform: menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
        }}
        src={arrow}
        alt="arrow icon"
      />
    </components.DropdownIndicator>
  );
};

export const FilterItem = ({
  handleOpenModal,
  text,
  value,
  options,
  handleOnChange,
  emoji,
  placeholder,
}) => {
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  return (
    <FilterWrapper>
      <Text style={{marginBottom: 4}} type={"bodyRegular"}>
        {text}
      </Text>
      <div style={{display: "flex", alignItems: "center"}}>
        <Emodji>{MOCK_DATA[emoji]}</Emodji>
        <div onClick={isMobile ? handleOpenModal : undefined} style={{all: "unset"}}>
          <Select
            components={{DropdownIndicator}}
            isDisabled={isMobile}
            placeholder={placeholder}
            value={value}
            onChange={handleOnChange}
            options={options}
            className="advanced-search-select-container"
            classNamePrefix="advanced-search-select"
          />
        </div>
      </div>
    </FilterWrapper>
  );
};

export const CTAAdvancedSearch = ({disabled, title, onClick}) => {
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  return (
    <CTAWrapper onClick={onClick}>
      <CTA
        disableLink={disabled}
        wrapperStyles={{marginTop: isMobile ? 0 : 22}}
        buttonStyles={{alignSelf: "flex-end"}}
        size="medium"
        type="primary"
      >
        {title}
      </CTA>
    </CTAWrapper>
  );
};

export const MobileModalsBlock = ({
  searchPage = false,
  modalsOpen: {isDestinationModalOpen, isDurationModalOpen},
  optionHandlers: {handleDestinationOption, handleDurationOption},
  closeHandlers: {handleCloseDurationModal, handleCloseDestinationModal},
  options: {destinationsOptions, durationsOptions},
}) => {
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  return (
    <>
      {isDestinationModalOpen && isMobile && (
        <MobileOptionsModal
          searchPage={searchPage}
          handleOption={handleDestinationOption}
          handleClose={handleCloseDestinationModal}
          options={destinationsOptions}
        />
      )}
      {isDurationModalOpen && isMobile && (
        <MobileOptionsModal
          searchPage={searchPage}
          handleOption={handleDurationOption}
          handleClose={handleCloseDurationModal}
          options={durationsOptions}
        />
      )}
    </>
  );
};
